var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0208 3.83757L14.8458 3.01258C15.5293 2.32914 16.6373 2.32914 17.3208 3.01258C18.0042 3.69603 18.0042 4.80411 17.3208 5.48756L16.4958 6.31255M14.0208 3.83757L8.47132 9.387C8.04839 9.81 7.74837 10.3398 7.60331 10.9201L7 13.3333L9.41325 12.73C9.9935 12.585 10.5233 12.2849 10.9463 11.862L16.4958 6.31255M14.0208 3.83757L16.4958 6.31255",
    stroke: "#26C3C0",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1667 11.2513C16.1667 13.9909 16.1667 15.3606 15.4102 16.2826C15.2717 16.4514 15.1169 16.6061 14.9481 16.7446C14.0262 17.5013 12.6563 17.5013 9.91675 17.5013H9.50016C6.35746 17.5013 4.78613 17.5013 3.80982 16.525C2.83352 15.5487 2.8335 13.9773 2.8335 10.8346V10.418C2.8335 7.6784 2.8335 6.30863 3.59011 5.38667C3.72864 5.21789 3.88341 5.06311 4.0522 4.92459C4.97415 4.16797 6.34393 4.16797 9.0835 4.16797",
    stroke: "#26C3C0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.0f64619d2a21cca90e3652ae2fd2cb81.svg";
export { ForwardRef as ReactComponent };